import { useQuery } from "@apollo/client";
import moment from "moment";
import {
  GetProfileActivitiesQueryQuery,
  GetProfileActivitiesQueryQueryVariables,
} from "types/graphql-schema";

import ArtifactActivity from "@apps/activities/components/artifact-activity";
import Button from "@components/button/button";
import { ButtonSize } from "@components/button/button-constants";
import Loading from "@components/loading/loading";
import { assertEdgesNonNull } from "@helpers/helpers";

import ProfileContainer from "../../profile-container";
import ProfileEmptyState from "../../profile-empty-state";
import getProfileActivitiesQuery from "../graphql/get-profile-activities-query";

const ProfileActivities = ({ profileId }: { profileId: number }) => {
  const createdAfter = moment()
    .subtract(30, "day")
    .startOf("day")
    .toISOString();
  const { data, loading, fetchMore } = useQuery<
    GetProfileActivitiesQueryQuery,
    GetProfileActivitiesQueryQueryVariables
  >(getProfileActivitiesQuery, {
    variables: { profileId, createdAfter },
  });

  const activities = data?.user?.activities
    ? assertEdgesNonNull(data.user.activities)
    : [];

  const handleClickLoadMore = () => {
    if (data?.user?.activities?.pageInfo?.hasNextPage) {
      fetchMore({
        variables: {
          after: data?.user?.activities?.pageInfo?.endCursor,
          merge: true,
        },
      });
    }
  };

  return (
    <ProfileContainer title="Recent Updates">
      {loading && !data ? (
        <Loading className="" />
      ) : activities.length > 0 ? (
        <div className="flex flex-col gap-5">
          {activities.map((activity) =>
            activity.artifact ? (
              <ArtifactActivity
                key={activity.id}
                activity={activity}
                artifact={activity.artifact}
                mentionArtifactName={true}
              />
            ) : null,
          )}
          {activities.length > 0 &&
            data?.user?.activities?.pageInfo?.hasNextPage && (
              <div className="flex justify-center gap-2">
                <Button
                  size={ButtonSize.medium}
                  text={loading ? "loading..." : "load more"}
                  onClick={handleClickLoadMore}
                  disabled={loading}
                />
              </div>
            )}
        </div>
      ) : (
        <ProfileEmptyState>No updates.</ProfileEmptyState>
      )}
    </ProfileContainer>
  );
};

export default ProfileActivities;
